<template>
    <div>

        <loading :active.sync="isLoadingPreview"
                 :can-cancel="false"
                 :is-full-page="false"></loading>


        <div class="card" v-if="!deleted && getPreviewIframeContent">

            <div class="card-header">{{$t('text.globals.documentPreview')}}</div>

            <div class="card-body bg-light" style="max-height: 1022px; overflow-y: scroll; padding-top: 20px; padding-bottom: 20px;"
                 v-if="$globalFunctions.getFileTypeFromMimeType(nodeData.content.mimeType) !== 'image' && $globalFunctions.getFileTypeFromMimeType(nodeData.content.mimeType) !== 'video' && $globalFunctions.getFileTypeFromMimeType(nodeData.content.mimeType) !== 'audio' && $globalFunctions.getFileTypeFromMimeType(nodeData.content.mimeType) !== 'html'">
                <pdf
                        v-for="i in numPages"
                        :key="i"
                        :src="getPreviewIframeContent"
                        :page="i"
                        :rotate="0"
                        style="width: 100%; height: 100%; margin-bottom: 10px"
                ></pdf>
            </div>

            <div class="card-body bg-light" style="max-height: 1022px; overflow-y: auto;"
                 v-if="$globalFunctions.getFileTypeFromMimeType(nodeData.content.mimeType) == 'video' || $globalFunctions.getFileTypeFromMimeType(nodeData.content.mimeType) === 'audio'">
                <iframe v-if="getPreviewIframeContent" :src="getPreviewIframeContent"
                        frameborder="0"
                        width="100%" height="1100" allowfullscreen webkitallowfullscreen></iframe>
            </div>

            <div class="card-body bg-light" style="max-height: 1022px; overflow-y: auto;"
                 v-if="$globalFunctions.getFileTypeFromMimeType(nodeData.content.mimeType) === 'image'">
                <img :src="getPreviewIframeContent" class="img-responsive" style="width: auto; max-width: 100%;" />
            </div>

            <div class="card-body bg-light" style="max-height: 1022px; overflow-y: auto;"
                 v-if="$globalFunctions.getFileTypeFromMimeType(nodeData.content.mimeType) === 'html'">
                <iframe :src="getPreviewIframeContent" frameborder="0"
                        width="100%" height="1100" allowfullscreen webkitallowfullscreen></iframe>
            </div>

        </div>
        <div v-else class="card-body">
            <div class="alert alert-info mt-3">
                <em><i class="fa fa-exclamation-triangle"></i> {{$t('text.globals.documentPreviewNotAvailable')}}</em>
            </div>
        </div>

    </div>

</template>


<script>
    import Vue from 'vue';
    import pdf from 'vue-pdf'
    import DocumentDetailsMetadata from "./DocumentDetailsMetadata";
    import Loading from "vue-loading-overlay";
    import vSelect from "vue-select";

    export default {
        name: 'DocumentDetailsMetadata',
        props: [
            "nodeOriginalData",
            "nodeData",
            "getPreviewIframeContent",
            "deleted",
            "isLoadingPreview",
            "numPages"
        ],
        components: {
            Vue,
            Loading,
            pdf
        },
        data() {
            return {};
        },
        mounted() {


        },
        methods: {

        },
    };
</script>



// WEBPACK FOOTER //
// src/components/DocumentDetailsPreview.vue